import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { CHECKOUT_B2B_CMS_COMPONENTS } from '@spartacus/checkout/b2b/root';
import { CheckoutQueryResetEvent, CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import * as i1 from '@spartacus/core';
import { provideDefaultConfigFactory } from '@spartacus/core';
import { RemoveCartEvent } from '@spartacus/cart/base/root';
import { ReplenishmentOrderScheduledEvent } from '@spartacus/order/root';
import { Subscription } from 'rxjs';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutScheduledReplenishmentEventListener {
  constructor(eventService) {
    this.eventService = eventService;
    this.subscriptions = new Subscription();
    this.onReplenishmentOrder();
  }
  onReplenishmentOrder() {
    this.subscriptions.add(this.eventService.get(ReplenishmentOrderScheduledEvent).subscribe(({
      userId,
      cartId,
      cartCode
    }) => {
      this.eventService.dispatch({
        userId,
        cartId,
        cartCode
      }, RemoveCartEvent);
      this.eventService.dispatch({}, CheckoutQueryResetEvent);
    }));
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function CheckoutScheduledReplenishmentEventListener_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutScheduledReplenishmentEventListener)(i0.ɵɵinject(i1.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CheckoutScheduledReplenishmentEventListener,
      factory: CheckoutScheduledReplenishmentEventListener.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckoutScheduledReplenishmentEventListener, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CheckoutScheduledReplenishmentEventModule {
  constructor(_checkoutScheduledReplenishmentEventListener) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function CheckoutScheduledReplenishmentEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutScheduledReplenishmentEventModule)(i0.ɵɵinject(CheckoutScheduledReplenishmentEventListener));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CheckoutScheduledReplenishmentEventModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckoutScheduledReplenishmentEventModule, [{
    type: NgModule,
    args: [{}]
  }], () => [{
    type: CheckoutScheduledReplenishmentEventListener
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CHECKOUT_SCHEDULED_REPLENISHMENT_CMS_COMPONENTS = [
/**
 *  TODO:#9574 - we should be able to remove the spread of `CHECKOUT_BASE_CMS_COMPONENTS`.
 * Re-test the B2B checkout flow after doing it.
 */
...CHECKOUT_B2B_CMS_COMPONENTS, 'CheckoutScheduleReplenishmentOrder'];
function defaultCheckoutComponentsConfig() {
  const config = {
    featureModules: {
      [CHECKOUT_FEATURE]: {
        cmsComponents: CHECKOUT_SCHEDULED_REPLENISHMENT_CMS_COMPONENTS
      }
    }
  };
  return config;
}
class CheckoutScheduledReplenishmentRootModule {
  static {
    this.ɵfac = function CheckoutScheduledReplenishmentRootModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckoutScheduledReplenishmentRootModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CheckoutScheduledReplenishmentRootModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfigFactory(defaultCheckoutComponentsConfig)],
      imports: [CheckoutScheduledReplenishmentEventModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckoutScheduledReplenishmentRootModule, [{
    type: NgModule,
    args: [{
      imports: [CheckoutScheduledReplenishmentEventModule],
      providers: [provideDefaultConfigFactory(defaultCheckoutComponentsConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CHECKOUT_SCHEDULED_REPLENISHMENT_CMS_COMPONENTS, CheckoutScheduledReplenishmentEventListener, CheckoutScheduledReplenishmentEventModule, CheckoutScheduledReplenishmentRootModule, defaultCheckoutComponentsConfig };
